import React from "react";
import Accordion from "../../../components/Accordion/Accordion";
import Button from "../../../components/Button/Button";

import { ReactComponent as GooglePlayIcon } from "../../../assets/svg/googleplay-logo-v2.svg";
import { ReactComponent as AppleIcon } from "../../../assets/svg/apple-logo-v2.svg";
import { ReactComponent as TopRightArrow } from "../../../assets/svg/top-right-arrow.svg";
import TorumPay from "../../../assets/png/torumpay-icon-png.png";
import TorumPayMock from "../../../assets/png/mock-iphone.png";

import "./Faq.scss";
import "../../../styles/variables.scss";
import "../../../styles/global.scss";

const faqs = [
  {
    question: "What is TorumPay?",
    answer:
      "TorumPay is a Malaysian digital asset platform where you can buy and sell cryptocurrencies in a secure, regulated environment. Additional features such as Ringgit payments and card spending will be introduced soon.",
  },
  {
    question: "Is TorumPay a licensed entity?",
    answer: (
      <>
        Yes, TorumPay is a provisionally registered digital asset exchange (DAX)
        operator,{" "}
        <a
          href="https://www.sc.com.my/regulation/guidelines/recognizedmarkets/list-of-registered-digital-asset-exchanges"
          target="_blank"
        >
          under the supervision of the Securities Commission Malaysia
        </a>
        .
      </>
    ),
  },
  {
    question: "Do I need to complete KYC to use TorumPay?",
    answer:
      "Yes, completing the Know Your Customer (KYC) process is mandatory to access trading and all upcoming financial features. This requirement is essential for your protection as an investor and to ensure compliance with regulatory standards.",
  },
  {
    question: "What is the TorumPay card?",
    answer:
      "The TorumPay card allows you to spend your Ringgit at merchants across Malaysia and worldwide upon conversion from cryptocurrencies on the TorumPay app. Upon successful application and subscription, you can enjoy seamless virtual card contactless payments, DuitNow QR payments, and will also receive a complimentary physical card and exclusive gift box delivered to your doorstep.",
  },
  {
    question: "Do I need to convert my crypto assets into MYR?",
    answer:
      "Yes, if you wish to withdraw funds to your bank account or spend them at merchants, you must first convert your crypto assets into Ringgit.",
  },
  {
    question: "Is there any requirement to apply for a TorumPay card?",
    answer:
      "To apply for a TorumPay card, you must first complete the KYC procedure on the TorumPay application. Additional details regarding the card application process will be available soon.",
  },
];

function HeroButtonGroup({ disabled = false }) {
  return (
    <div className="tp-hero-button-container">
      <div className="tp-hero-button-wrapper">
        <Button
          className={`filled-expand ${disabled ? "disabled" : ""}`}
          icon={GooglePlayIcon}
          // href="https://google.com" (pending for go-live confirmation)
          target="_blank"
          disabled={disabled}
        >
          Coming soon to Android
        </Button>
        <Button
          className={`filled-expand-dark ${disabled ? "disabled" : ""}`}
          icon={AppleIcon}
          // href="https://google.com" (pending for go-live confirmation)
          target="_blank"
          disabled={disabled}
        >
          Coming soon to iOS
        </Button>
      </div>
    </div>
  );
}

const Faq = () => {
  return (
    <div className="tp-main-faq">
      <div className="tp-main-faq-wrapper">
        <div className="faq-header">
          <p className="faq-title">Frequently Asked Questions</p>
          <p className="faq-desc">
            We understand that you might have questions in mind, and we’ve got
            you covered.
          </p>
        </div>

        <div className="tp-faq-grid">
          <Accordion faqs={faqs.slice(0, Math.ceil(faqs.length / 2))} />
          <Accordion faqs={faqs.slice(Math.ceil(faqs.length / 2))} />
        </div>

        {/* <Button className="empty reversed-rr link" icon={TopRightArrow}>
          For more FAQs
        </Button> */}

        <div className="tp-cta-comingsoon-main-container">
          <div className="cta-left-wrapper">
            <img src={TorumPay} />
            <div className="text-wrapper">
              <div className="Fu-70s-70l">GET STARTED WITH TORUMPAY NOW</div>
              <div className="Ft-20s-26l">
                Experience the power of the ultimate fiat-to-crypto ramp,
                optimized for instant, secure access from anywhere in the world.
              </div>
            </div>
            <HeroButtonGroup />
          </div>

          <div>
            <img src={TorumPayMock} className="cta-image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
